import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { cn } from "../lib/utils.js";
import { StickToBottom, useStickToBottomContext } from "use-stick-to-bottom";
const Conversation = ({ className, ...props }) => /* @__PURE__ */ jsx(
  StickToBottom,
  {
    className: cn("tw:relative tw:flex-1 tw:overflow-hidden", className),
    initial: "smooth",
    resize: "smooth",
    role: "log",
    ...props
  }
);
const ConversationContent = ({ className, ...props }) => /* @__PURE__ */ jsx(StickToBottom.Content, { className: cn("tw:p-4", className), ...props });
const ConversationEmptyState = ({
  className,
  title = "No messages yet",
  description = "Start a conversation to see messages here",
  icon,
  children,
  ...props
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "tw:flex tw:size-full tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:p-8 tw:text-center",
      className
    ),
    ...props,
    children: children ?? /* @__PURE__ */ jsxs(Fragment, { children: [
      icon && /* @__PURE__ */ jsx("div", { className: "tw:text-muted-foreground", children: icon }),
      /* @__PURE__ */ jsxs("div", { className: "tw:space-y-1", children: [
        /* @__PURE__ */ jsx("h3", { className: "tw:font-medium tw:text-sm", children: title }),
        description && /* @__PURE__ */ jsx("p", { className: "tw:text-muted-foreground tw:text-sm", children: description })
      ] })
    ] })
  }
);
const ConversationScrollButton = ({ className, ...props }) => {
  const { isAtBottom, scrollToBottom } = useStickToBottomContext();
  const handleScrollToBottom = useCallback(() => {
    scrollToBottom();
  }, [scrollToBottom]);
  if (isAtBottom) return null;
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: cn("tw:absolute tw:bottom-4 tw:left-1/2 tw:-translate-x-1/2", className),
      onClick: handleScrollToBottom,
      type: "button",
      "aria-label": "Scroll to bottom",
      style: {
        width: 24,
        height: 24,
        borderRadius: "50%",
        backgroundColor: "#FFFFFF",
        border: "1px solid #DCDDDC",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: 0
      },
      ...props,
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          width: "11",
          height: "7.4",
          viewBox: "0 0 11.0575 7.39064",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          style: { transform: "rotate(90deg)" },
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.8826 3.27338C10.8825 3.27323 10.8823 3.27301 10.8821 3.27285L7.76778 0.173545C7.53447 -0.0586046 7.1571 -0.0577646 6.92486 0.175575C6.69265 0.408885 6.69354 0.786265 6.92686 1.01846L9.01782 3.0993H0.59602C0.26684 3.0993 0 3.36612 0 3.69531C0 4.0245 0.26684 4.29138 0.59602 4.29138H9.01779L6.9269 6.37216C6.69359 6.60438 6.69269 6.9817 6.9249 7.21506C7.15714 7.44843 7.53454 7.44925 7.76782 7.21707L10.8821 4.11775C10.8823 4.11757 10.8825 4.11738 10.8827 4.1172C11.1161 3.88423 11.1154 3.50563 10.8826 3.27339V3.27338Z",
              fill: "black"
            }
          )
        }
      )
    }
  );
};
export {
  Conversation,
  ConversationContent,
  ConversationEmptyState,
  ConversationScrollButton
};
//# sourceMappingURL=conversation.js.map
